import React from "react";
import PortfolioSimulator from "./PortfolioSimulator";

export default function App() {
  return <PortfolioSimulator />;
}
